import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useIsInternalAdCreation from '../../../../../features/hooks/internalAdHooks/useIsInternalAdCreation'

import { createAdsBatch } from '../../../../../modules/actions/ads'
import { selectedDV360AdAccountSelector } from '../../../../../modules/selectors/adAccounts'
import { selectedPartnershipRightsHolderIdSelector } from '../../../../../modules/selectors/partnerships'
import { dv360RightUploadAdDataSelector } from '../../../../../modules/selectors/rights'
import { campaignSelector } from '../../../../../modules/selectors/campaigns'
import { lineItemSelector } from '../../../../../modules/selectors/lineItems'

import { IS_QUARANTINE } from '../../../../reusableFields'
import { DV_360_PLATFORM } from '../../../../../constants/selectLists/platformList'

export const useSubmitDv360CreateAdsBatch = () => {
  const dispatch = useDispatch()
  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)

  const rightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)
  const isInternalAdCreation = useIsInternalAdCreation()

  return useCallback(
    (formattedData, values) => {
      dispatch(
        createAdsBatch(
          {
            account: selectedAdAccountId,
            ...formattedData,
            // isInternalAdCreation is default, also allow to pass it manually if user has ability to select it(values[IS_QUARANTINE])
            ...((isInternalAdCreation || values[IS_QUARANTINE]) && {
              quarantine: true,
              ...(rightsHolderId && { account_id: rightsHolderId, rights_holder_account_id: rightsHolderId })
            })
          },
          DV_360_PLATFORM
        )
      )
    },
    [dispatch, selectedAdAccountId, rightsHolderId, isInternalAdCreation]
  )
}

export const useSubmitDv360CreateAdsParams = () => {
  const { id: selectedAdAccountId } = useSelector(selectedDV360AdAccountSelector)
  const { lineItem: rightUploadAdLineItemData, campaign: rightUploadAdCampaignData } =
    useSelector(dv360RightUploadAdDataSelector)
  const { id: campaignId } = useSelector(campaignSelector)
  const { id: lineItemId } = useSelector(lineItemSelector)

  const { id: rightUploadAdLineItemId } = rightUploadAdLineItemData
  const { id: rightUploadAdCampaignId } = rightUploadAdCampaignData

  const rightsHolderId = useSelector(selectedPartnershipRightsHolderIdSelector)
  const isInternalAdCreation = useIsInternalAdCreation()

  return useMemo(() => {
    return {
      // if right upload line item and campaign ids exist, use it instead of  usual selector
      campaignId: rightUploadAdCampaignId ? rightUploadAdCampaignId : campaignId,
      lineItemId: rightUploadAdLineItemId ? rightUploadAdLineItemId : lineItemId,
      account: selectedAdAccountId,
      rightsHolderId,
      isInternalAdCreation
    }
  }, [
    selectedAdAccountId,
    campaignId,
    lineItemId,
    rightUploadAdCampaignId,
    rightUploadAdLineItemId,
    rightsHolderId,
    isInternalAdCreation
  ])
}
